module.exports = __webpack_public_path__ + "img/ic_equipment-white.d1781369.svg";